import { h, render } from 'preact'

export class Island {
	constructor({ element, component, props = {} }) {
		this.element = element
		this.component = component
		this.props = props
		this.listeners = new Map()
		this.commandListeners = new Map()
		this.bridge = {
			emit: this.emit.bind(this),
			on: this.on.bind(this),
			command: this.command.bind(this),
			onCommand: this.onCommand.bind(this),
			unsetCommand: this.unsetCommand.bind(this),
		}
	}
	render() {
		render(
			h(this.component, {
				...this.props,
				bridge: this.bridge,
			}),
			this.element,
		)
	}
	mount() {
		if (!this.element) return
		this.render()
	}
	update(nextProps = {}) {
		this.props = {
			...this.props,
			...nextProps,
		}
		this.render()
	}
	unmount() {
		render(null, this.element)
		this.listeners.clear()
	}

	onCommand(command, callback) {
		if (!this.commandListeners.has(command)) {
			this.commandListeners.set(command, [])
		}
		this.commandListeners.get(command).push(callback)
	}
	unsetCommand(command, callback) {
		if (!this.commandListeners.has(command)) return
		const callbacks = this.commandListeners.get(command)
		const index = callbacks.indexOf(callback)
		if (index !== -1) {
			callbacks.splice(index, 1)
		}
	}

	command(command, payload) {
		const callbacks = this.commandListeners.get(command)
		if (!callbacks) return
		callbacks.forEach((callback) => callback(payload))
	}
	on(event, callback) {
		if (!this.listeners.has(event)) {
			this.listeners.set(event, [])
		}
		this.listeners.get(event).push(callback)
	}
	emit(event, payload) {
		const callbacks = this.listeners.get(event)
		if (!callbacks) return
		callbacks.forEach((callback) => callback(payload))
	}
}
